// Filters for the resident List table header drop-down filter menu
export const INSTALLATION = {
  installation: "Installation status",
  complete: "Installation completed",
  started: "Installation started",
  "not started": "Installation not started",
};

export const FILTERS = {
  all: "All residents",
  AT_RISK: "At risk residents",
  UNEXPECTED: "Unexpected residents",
  EXPECTED: "Expected residents",
  friends_and_family: "Assigned Friend/Family",
  no_friends_and_family: "Not assigned Friend/Family",
  ...INSTALLATION,
  incomplete: "Installation incomplete (started & not started)",
};

export const INSTALLER_FILTERS = {
  ...INSTALLATION,
};
